/**
 * API do Portal
 */
import axios from 'axios'

const fetchEditions = function (page) {
  return axios.get('editions/published?page=' + page).then((response) => {
    return response.data
  })
}

const fetchSelectedEditions = function (year, month) {
  return axios
    .get('editions/published/' + year + '/' + month)
    .then((response) => {
      return response.data
    })
}

const fetchLegislations = function (page) {
  return axios.get('legislations/published?page=' + page).then((response) => {
    return response.data
  })
}

const fetchSelectedLegislations = function (year, month, page, perPage) {
  return axios
    .get(
      'legislations/published/' +
        year +
        '/' +
        month +
        '?page=' +
        page +
        '&perPage=' +
        perPage
    )
    .then((response) => {
      return response.data
    })
}

const fetchSelectedLegislationsByType = function (
  year,
  month,
  type,
  page,
  perPage
) {
  return axios
    .get(
      'legislations/published/' +
        year +
        '/' +
        month +
        '/' +
        type +
        '?page=' +
        page +
        '&perPage=' +
        perPage
    )
    .then((response) => {
      return response.data
    })
}

const fetchPublishPortal = function (body) {
  const parsedValues = {
    pessoaTipo: 'kind_person',
    nome: 'full_name',
    cep: 'zip_code',
    endereco: 'street_address',
    cpf: 'cpf',
    cnpj: 'cnpj',
    numero: 'number',
    telefone: 'phone',
    complemento: 'complement',
    email: 'mail',
    bairro: 'neighborhood',
    cidade: 'city',
    uf: 'state',
    arquivos: 'file'
  }

  const formData = new FormData()
  Object.keys(body).forEach((element) => {
    if (body[element]) {
      formData.append(parsedValues[element], body[element])
    }
  })

  return axios
    .post('mail/send', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
}

const searchEditions = function (page, data) {
  return axios.post('editions/searchES?page=' + page, data).then((response) => {
    this.filter_year = response.data.result.aggregations.year.buckets.map(
      (item) => {
        return {
          text: item.key + ' (' + item.doc_count + ') ',
          value: item.key
        }
      }
    )

    this.filter_edition_type =
      response.data.result.aggregations.edition_type_name.buckets.map(
        (item) => {
          return {
            text: item.key + ' (' + item.doc_count + ') ',
            value: item.key
          }
        }
      )

    this.filter_suplement =
      response.data.result.aggregations.suplement.buckets.map((item) => {
        return {
          text:
            (item.key === 0 ? 'Normal' : 'Suplemento') +
            ' (' +
            item.doc_count +
            ') ',
          value: item.key_as_string
        }
      })

    return {
      items: response.data.result.items,
      filter_year: this.filter_year,
      filter_edition_type: this.filter_edition_type,
      filter_suplement: this.filter_suplement,
      total_rows: response.data.result.total_rows,
      max_date: response.data.result.aggregations.max_date.value_as_string,
      min_date: response.data.result.aggregations.min_date.value_as_string
    }
  })
}

const searchLegislations = function (page, data) {
  return axios
    .post('legislations/searchES?page=' + page, data)
    .then((response) => {
      this.filter_year = response.data.result.aggregations.year.buckets.map(
        (item) => {
          return {
            text: item.key + ' (' + item.doc_count + ') ',
            value: item.key
          }
        }
      )

      this.filter_edition_type =
        response.data.result.aggregations.edition_type_name.buckets.map(
          (item) => {
            return {
              text: item.key + ' (' + item.doc_count + ') ',
              value: item.key
            }
          }
        )

      this.filter_suplement =
        response.data.result.aggregations.suplement.buckets.map((item) => {
          return {
            text:
              (item.key === 0 ? 'Normal' : 'Suplemento') +
              ' (' +
              item.doc_count +
              ') ',
            value: item.key_as_string
          }
        })

      return {
        items: response.data.result.items,
        filter_year: this.filter_year,
        filter_edition_type: this.filter_edition_type,
        filter_suplement: this.filter_suplement,
        total_rows: response.data.result.total_rows,
        max_date: response.data.result.aggregations.max_date.value_as_string,
        min_date: response.data.result.aggregations.min_date.value_as_string
      }
    })
}

export default {
  fetchEditions,
  fetchSelectedEditions,
  fetchLegislations,
  fetchSelectedLegislations,
  fetchSelectedLegislationsByType,
  fetchPublishPortal,
  searchEditions,
  searchLegislations
}



// WEBPACK FOOTER //
// ./src/api/portal.js